import React from "react";
import { ClipLoader } from "react-spinners";

const PrintedModal = ({ isOpen, onClose, isProcessing }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg max-w-sm w-full">
        <h3 className="text-xl font-semibold mb-4">Confirm Handover</h3>
        <p className="text-gray-700">Are you sure you want to mark this order as handed over?</p>
        <div className="flex justify-between items-center space-x-4 mt-4">
          <button
            onClick={() => onClose("Yes")}
            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center justify-center"
            disabled={isProcessing}
          >
            {isProcessing ? <ClipLoader color="#ffffff" size={20} /> : "Yes"}
          </button>
          <button
            onClick={() => onClose("No")}
            className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintedModal;
